module.exports = __webpack_public_path__ + "static/img/product-swipe34.70f6288c.png";